import { seriesColourClass, type SeriesColourSlot } from './parameterColours';
import './ParameterSwatch.css';

export interface ParameterSwatchProps {
  slot: SeriesColourSlot;
}

/**
 * The colour key of a parameter's series (legend, chart heading, table row).
 * Decorative: it always sits next to the parameter's name.
 */
export function ParameterSwatch({ slot }: ParameterSwatchProps) {
  return <span className={`parameter-swatch ${seriesColourClass(slot)}`} aria-hidden="true" data-slot={slot} />;
}

export default ParameterSwatch;
